import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Select,
  Icon,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Pagination from "@mui/material/Pagination";
import {
  canEditClasses,
  canViewReviews,
  canViewSessions,
  capitalizeFirstLetter,
} from "../../Helpers";
import {
  ImagesIcon,
  CategoriesIcon,
  EditIcon,
  TextInRowsFilledIcon,
  PriceListFilledIcon,
} from "@shopify/polaris-icons";
import { ArrowDownIcon, ArrowUpIcon } from "@shopify/polaris-icons";

const Classes = (props) => {
  const navigate = useNavigate();
  const addEditState = useRef("");
  const perPage = 50;
  const [ts, setTs] = useState("");
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageObject, setPageObject] = useState({
    isLoading: true,
    isSaving: false,
    tableItems: [],
    tableTotalPages: 0,
    isListEmpty: false,
  });
  const handleAddClass = () => {
    navigate("/admin/classes/new");
  };
  const handleAddEvent = () => {
    navigate("/admin/events/new");
  };
  const handleBulk = () => {
    navigate("/admin/classes/bulk-sessions");
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    {
      key: "availability",
      label: "Filter by",
      filter: (
        <ChoiceList
          title="Filter by"
          titleHidden
          choices={[{ label: "Name", value: "name" }]}
          selected={availability || []}
          onChange={handleAvailabilityChange}
        />
      ),
      shortcut: false,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = pageObject.isLoading ? <Loading /> : null;
  const emtyState = pageObject.isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="bodyLg" as="p">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    pageObject.isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const handleEdit = (id) => {
    //navigate(`/admin/${props.path}/${id}`);
    window.open(`/admin/${props.path}/${id}`, "_blank");
  };
  const handleGallery = (id) => {
    navigate(`/admin/classes/${id}/gallery`);
  };
  const handleSessions = (id, type) => {
    localStorage.setItem("class_type", type);
    navigate(`/admin/${props?.path}/${id}/sessions`);
  };
  const handlePricingOptions = (id, type) => {
    navigate(`/admin/${props?.path}/${id}/pricing-options`);
  };
  const handleReviews = (id) => {
    navigate(`/admin/${props?.path}/${id}/reviews`);
  };
  const [optionsElements, setOptionsElements] = useState([
    { label: "All", value: "all" },
  ]);
  const [selectedElement, setSelectedElement] = useState(
    localStorage.getItem("filter_element")
      ? localStorage.getItem("filter_element")
      : ""
  );
  const handleSelectChangeElement = (newValue) => {
    localStorage.setItem("filter_element", newValue);
    setSelectedElement(newValue);
  };
  const handleUp = (e) => {
    const bodyObj = {
      direction: "up",
    };
    axios
      .post(`/${props.path}/${e.currentTarget.id}/sort`, bodyObj)
      .then((res) => {
        fetchData();
      })
      .catch((err) => console.log(""));
  };
  const handleDown = (e) => {
    const bodyObj = {
      direction: "down",
    };
    axios
      .post(`/${props.path}/${e.currentTarget.id}/sort`, bodyObj)
      .then((res) => {
        fetchData();
      })
      .catch((err) => console.log(""));
  };
  useEffect(() => {
    setPageObject({
      ...pageObject,
      isLoading: true,
      isSaving: false,
      tableItems: [],
      tableTotalPages: 0,
      isListEmpty: false,
    });
    fetchData();
  }, [ts, availability, queryValue, page, selectedElement, props]);

  async function fetchData() {
    let responseClasses = "";
    let responseElements = "";
    try {
      responseClasses = await axios.get(
        `/classes?per_page=${perPage}&page=${refBoolPage.current ? page : 1}${
          queryValue
            ? `&filter[${
                availability === "" ? "name" : availability
              }]=${queryValue}`
            : ""
        }${
          props?.path === "classes"
            ? `&filter[is_event]=0`
            : "&filter[is_event]=1"
        }${
          props?.path === "classes"
            ? selectedElement !== "" && selectedElement !== "all"
              ? `&filter[element_id]=${selectedElement}`
              : ""
            : ``
        }`
      );
      setPageObject({
        ...pageObject,
        tableItems: responseClasses.data.data.data.map((item, index) => [
          item?.id,
          item?.background_image ? (
            <Thumbnail size="extraSmall" source={item.background_image} />
          ) : (
            "-"
          ),
          item?.name ? item.name : "-",
          item?.price !== null ? item.price : "-",
          props.path === "events" && (!item.is_retreat ? "EVENT" : "ETHER"),
          item?.type ? (
            <Badge
              tone={
                item.type === "spot"
                  ? "attention"
                  : item.type === "duration"
                  ? "info"
                  : ""
              }
            >
              {capitalizeFirstLetter(item.type)}
            </Badge>
          ) : (
            "-"
          ),
          props.path === "classes" && item?.parent_type === "element"
            ? item.element?.title
            : item?.parent_type === "studio"
            ? item.studio?.name
            : item.sub_studio?.name,

          item.is_private ? "Yes" : "No",

          // item?.parent_type ? (
          //   <Text
          //     tone={
          //       item.parent_type === "element"
          //         ? "subdued"
          //         : item.parent_type === "studio"
          //         ? "success"
          //         : "caution"
          //     }
          //   >
          //     {capitalizeFirstLetter(item.parent_type)}
          //   </Text>
          // ) : (
          //   "-"
          // ),
          // item.element.title,
          // item?.parent_type === "studio" || item?.parent_type === "substudio"
          //   ? item?.studio?.name
          //   : "-",
          // item?.parent_type === "substudio" &&
          // item.sub_studio &&
          // item?.sub_studio?.name
          //   ? item?.sub_studio?.name
          //   : "-",
          // item?.created_at
          //   ? moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")
          //   : "-",
          <Badge tone={item.is_active ? "success" : "info"}>
            {item.is_active ? "Active" : "Draft"}
          </Badge>,
          <ButtonGroup>
            <Button
              id={String(item.id)}
              onClick={(e) => handleUp(e)}
              disabled={!canEditClasses()}
            >
              <Icon source={ArrowUpIcon}></Icon>
            </Button>
            <Button
              id={String(item.id)}
              onClick={(e) => handleDown(e)}
              disabled={!canEditClasses()}
            >
              <Icon source={ArrowDownIcon}></Icon>
            </Button>
            <Button
              onClick={() => handleSessions(item.id, item.type)}
              icon={CategoriesIcon}
              disabled={!canViewSessions()}
            >
              Sessions
            </Button>
            {props?.path == "events" ? (
              <Button
                onClick={() => handlePricingOptions(item.id, item.type)}
                icon={PriceListFilledIcon}
                disabled={item.is_retreat === 0}
              >
                Pricing Options
              </Button>
            ) : null}
            <Button
              onClick={() => handleEdit(item.id)}
              icon={EditIcon}
              disabled={!canEditClasses()}
            >
              Edit
            </Button>
            {/* <Button onClick={() => handleGallery(item.id)} icon={ImagesIcon}>
              Gallery
            </Button> */}
            <Button
              onClick={() => handleReviews(item.id)}
              icon={TextInRowsFilledIcon}
              disabled={!canViewReviews()}
            >
              Reviews
            </Button>
          </ButtonGroup>,
        ]),
        isLoading: false,
        isListEmpty: !responseClasses.data.data.data.length ? true : false,
        tableTotalPages: responseClasses.data.data.total,
      });
    } catch (error) {
      console.log(error);
    }

    if (optionsElements.length === 1)
      try {
        responseElements = await axios.get(`/elements`);
        setOptionsElements((currentObjects) =>
          currentObjects.concat([
            ...responseElements.data.data.data.map((item, index) => {
              return {
                label: item.title,
                value: String(item.id),
                key: String(item.id),
              };
            }),
          ])
        );
      } catch (error) {
        console.log(error);
      }
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This professor has been successfully deleted"
  );

  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;

  return (
    <Page
      fullWidth
      title={props?.title}
      primaryAction={
        props?.path === "classes" ? (
          <ButtonGroup>
            <Button
              variant="primary"
              onClick={handleBulk}
              disabled={!canEditClasses()}
            >
              Bulk Add Sessions
            </Button>

            <Button
              variant="primary"
              onClick={handleAddClass}
              disabled={!canEditClasses()}
            >
              Add Class
            </Button>
          </ButtonGroup>
        ) : (
          <Button
            variant="primary"
            onClick={handleAddEvent}
            disabled={!canEditClasses()}
          >
            Add event
          </Button>
        )
      }
    >
      <Card padding="0">
        {loadingMarkup}

        <FormLayout>
          {props?.path === "classes" ? (
            <Select
              label="Filter by element:"
              options={optionsElements}
              onChange={handleSelectChangeElement}
              value={selectedElement}
              labelInline
            />
          ) : null}

          <Filters
            queryValue={queryValue}
            queryPlaceholder="Search..."
            filters={filters}
            appliedFilters={appliedFilters}
            onQueryChange={handleFiltersQueryChange}
            onQueryClear={handleQueryValueRemove}
            onClearAll={handleFiltersClearAll}
          />
        </FormLayout>

        <DataTable
          columnContentTypes={["text", "text", "text", "text"]}
          headings={[
            <Text variant="bodyMd" as="p" fontWeight="medium">
              ID
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Image
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Name
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Price
            </Text>,
            props.path === "events" && (
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Event/Ether
              </Text>
            ),
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Layout
            </Text>,
            props.path === "classes" && (
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Parent
              </Text>
            ),
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Is Private?
            </Text>,
            // <Text variant="bodyMd" as="p" fontWeight="medium">
            //   Element
            // </Text>,
            // <Text variant="bodyMd" as="p" fontWeight="medium">
            //   Studio
            // </Text>,
            // <Text variant="bodyMd" as="p" fontWeight="medium">
            //   Substudio
            // </Text>,
            // <Text variant="bodyMd" as="p" fontWeight="medium">
            //   Created at
            // </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
          ]}
          rows={pageObject.tableItems}
          verticalAlign="middle"
          increasedTableDensity
          footerContent={
            pageObject.tableItems?.length &&
            `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
          }
          hasZebraStripingOnData
        />
        {emtyState}
        {Math.ceil(pageObject.tableTotalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <Pagination
              variant="outlined"
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
            />
            {/* <Pagination
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            /> */}
          </div>
        )}

        {toastMarkup}
      </Card>
    </Page>
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default Classes;
